import React, { useState } from "react";
import { Box, Typography, InputBase, Stack, Tooltip } from "@mui/material";
import { Search as SearchIcon, Add as AddIcon, Done as DoneIcon } from "@mui/icons-material";

const ConditionsChecklist = ({ themeColors, value = [], onChange }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const items = [
    "Aggression", "Alcoholic", "Allergic to Ramipril", "Allergies", "Alzheimer's", 
    "Anticoagulants", "Arthritis", "Asthma", "Autism", "Barcode placed", "Bed rails", 
    "Behaviour that Challenges", "Best interest complete", "Blind", "Choking risk", 
    "COPD", "Confusion/ Delirium", "Coronary Heart Disease", "Covert medication", 
    "Deaf", "Dementia", "Diabetes", "Dialysis", "Domestic", "Double hand Client", 
    "End of life care", "Epilepsy", "Escort", "Has Attorneys or deputies", 
    "Hearing Impaired", "High fall risk", "HIV", "Hypertension", "Initial contact", 
    "Lacks capacity", "Learning Disability", "Log book check", "Low body weight", 
    "Mental health", "Mood Disorder", "Nutrition needs", "Palliative Care", 
    "Parkinsons", "Personal Care", "Physical disability", "Poor eating", 
    "PRN medications", "Prompt medication", "Repositioning", "Respiratory Disease", 
    "Risk of missing", "Seizure", "Self-medicate", "Skin ulcers", "Smokers", 
    "Stoma", "Stroke/CVA", "Used hoist", "Paraffin cream", "Visually Impaired", 
    "Weekly packages"
  ];

  const filteredItems = items.filter(i => i.toLowerCase().includes(searchTerm.toLowerCase()));

  const handleToggle = (item) => {
    const next = value.includes(item) ? value.filter(i => i !== item) : [...value, item];
    onChange(next);
  };

  return (
    <Box>
      {/* Search Bar - Floating Style */}
      <Box sx={{ 
        mb: 4, px: 2, py: 1, 
        bgcolor: "#ffffff", borderRadius: "100px", 
        display: "flex", alignItems: "center",
        boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
        border: "1px solid #f1f5f9",
        maxWidth: 400
      }}>
        <SearchIcon sx={{ color: "#94a3b8", mr: 1.5 }} />
        <InputBase 
          fullWidth 
          placeholder="Search conditions..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ fontSize: "0.9rem", fontWeight: 500 }}
        />
      </Box>

      {/* Unique Mesh Layout */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
        {filteredItems.map((item) => {
          const isSelected = value.includes(item);
          return (
            <Tooltip title={isSelected ? "Remove" : "Add"} arrow key={item}>
              <Box
                onClick={() => handleToggle(item)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2.5,
                  py: 1,
                  borderRadius: "100px",
                  userSelect: "none",
                  transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
                  border: "1px solid",
                  borderColor: isSelected ? "transparent" : "#e2e8f0",
                  background: isSelected 
                    ? `linear-gradient(135deg, ${themeColors?.accent || '#6366f1'} 0%, #4338ca 100%)` 
                    : "white",
                  color: isSelected ? "white" : "#475569",
                  boxShadow: isSelected 
                    ? "0 8px 15px -3px rgba(99, 102, 241, 0.4)" 
                    : "0 1px 2px rgba(0,0,0,0.05)",
                  "&:hover": {
                    transform: "scale(1.05)",
                    borderColor: isSelected ? "transparent" : themeColors?.accent,
                    boxShadow: isSelected 
                      ? "0 10px 20px -5px rgba(99, 102, 241, 0.5)" 
                      : "0 4px 10px rgba(0,0,0,0.08)",
                  },
                  "&:active": { transform: "scale(0.95)" }
                }}
              >
                {isSelected ? (
                  <DoneIcon sx={{ fontSize: 16, color: "white" }} />
                ) : (
                  <AddIcon sx={{ fontSize: 16, color: "#94a3b8" }} />
                )}
                <Typography sx={{ fontSize: "0.85rem", fontWeight: isSelected ? 700 : 500 }}>
                  {item}
                </Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Box>

      {filteredItems.length === 0 && (
        <Typography sx={{ textAlign: 'center', py: 10, color: '#94a3b8', fontStyle: 'italic' }}>
          No medical conditions found matching your search...
        </Typography>
      )}
    </Box>
  );
};

export default ConditionsChecklist;